<template>
	<div class="questionnaire">
		<b-container fluid>
			<section v-if="loading">
				<loader></loader>
			</section>

			<section v-else>
				<form-wizard
					:title="client.client_name"
					subtitle="Parlez nous de vous"
					back-button-text="Précédent"
					next-button-text="Suivant"
					finish-button-text="Envoyez"
					@on-complete="onSubmit"
				>
					<tab-content
						title="Charte Graphique"
						:before-change="beforeTabSwitch"
					>
						<h2>Personnaliser sa charte</h2>

						<b-row class="justify-content-md-center">
							<b-col col md="10">
								<graphics
									:graphics="graphics"
									:inputData.sync="graphics"
								></graphics>
							</b-col>
						</b-row>
					</tab-content>

					<tab-content
						title="Services en vedette"
						:before-change="beforeTabSwitch"
					>
						<h2>
							Sélectionnez 10 services max - qui sont vos plus
							forts atouts
						</h2>

						<b-row class="justify-content-md-center">
							<b-col col lg="8">
								<fieldset>
									<div class="checkbox-container">
										<b-form-checkbox
											v-for="service in services"
											v-model="selected_services"
											:key="service.id"
											:value="service.value"
											:disabled="
												isFeaturedServiceDisabled(
													service.value
												)
											"
										>
											{{ service.text }}
										</b-form-checkbox>
									</div>
								</fieldset>
							</b-col>
						</b-row>
					</tab-content>

					<tab-content title="Services en Chambre">
						<h2>
							Cochez ici les services disponible dans
							<strong>toutes</strong> vos chambres
						</h2>

						<p>
							Vous pourrez ajouter des services spécifiques aux
							différents types de chambre à la prochaine étape
						</p>

						<fieldset>
							<div
								v-for="category in room_services"
								:key="category.id"
								class="room-service-category"
							>
								<h3>{{ category.name }}</h3>

								<div class="checkbox-container">
									<b-form-checkbox
										v-for="(service,
										index) in category.service"
										:key="service.id"
										v-model="selected_room_services"
										:name="'room_service_' + index"
										:value="service.id"
									>
										{{ service.name }}
									</b-form-checkbox>
								</div>
							</div>
						</fieldset>
					</tab-content>

					<tab-content title="Chambres">
						<h2>Catégories de chambre</h2>
						<rooms
							:rooms="rooms"
							:room_services="room_services"
							:selected_room_services="selected_room_services"
							v-bind.sync="rooms"
						></rooms>
					</tab-content>

					<tab-content
						title="Conditions générales"
						:before-change="beforeTabSwitch"
					>
						<h2>
							Renseignez ici vos conditions & informations utiles
						</h2>

						<b-row class="justify-content-md-center">
							<b-col col lg="8">
								<conditions
									:conditions="conditions"
									:payment_methods="payment_methods"
									:available_handicap_adaptations="
										available_handicap_adaptations
									"
									v-bind.sync="conditions"
								></conditions>
							</b-col>
						</b-row>
					</tab-content>

					<tab-content
						title="Mentions légales"
						:before-change="beforeTabSwitch"
					>
						<h2>
							Remplissez ici vos coordonnées et mentions légales
						</h2>

						<b-row class="justify-content-md-center">
							<b-col col md="10">
								<legal
									:legal="legal"
									:inputData.sync="legal"
								></legal>
							</b-col>
						</b-row>
					</tab-content>
				</form-wizard>
			</section>
		</b-container>
	</div>
</template>

<script>
import Loader from './Loader.vue';
import Legal from './FormLegal.vue';
import Graphics from './FormGraphics.vue';
import Conditions from './FormConditions.vue';
import Rooms from './FormRooms.vue';

export default {
	name: 'Questionnaire',
	components: {
		Loader,
		Legal,
		Graphics,
		Conditions,
		Rooms,
	},
	data() {
		return {
			loading: true,
			client: {
				client_name: '',
			},
			is_completed: false,
			legal: {
				title: '',
				stars: '',
				address: '',
				address2: '',
				post_code: '',
				city: '',
				telephone: '',
				email: '',
				site_owner: '',
				business_number: '',
				business_address: '',
				tva_number: '',
				legal_status: '',
				capital: '',
				publication_director: '',
				publication_director_contact: '',
				consumer_mediator: '',
			},
			graphics: {
				clientele_type: '',
				color_preferences: '',
				color_dislikes: '',
				logo: '',
				motif_ideas: '',
				design_adjectives: '',
				example_sites: '',
				unique_selling_points: '',
				principal_rivals: '',
			},
			conditions: {
				check_in_time_from: {
					HH: '14',
					mm: '00',
				},
				check_in_time_limit: false,
				check_in_time_to: {
					HH: '01',
					mm: '00',
				},

				check_out_time_limit: true,
				check_out_time_to: {
					HH: '11',
					mm: '00',
				},
				checkinExtraConditions: '',
				has_tourism_tax: true,
				tourism_tax_amount: '',
				has_automatic_reception: false,
				has_twenty_four_hour_reception: false,
				reception: '',
				free_cancellation: true,
				free_cancellation_days_before: 1,
				free_cancellation_time: {
					HH: '18',
					mm: '00',
				},
				cancellationConditions: '',
				first_night_billed: false,
				cancellation_charge: '',
				accepted_payment_methods: '',
				is_wifi_available: true,
				is_wifi_free: true,
				supplement_wifi: '',
				is_breakfast_available: true,
				breakfast_price: 9.5,
				supplement_breakfast_in_room: '',
				has_reduced_breakfast_price_for_children: false,
				breakfast_price_reduced_for_children_max_age: 12,
				breakfast_price_reduced_for_children: '',
				breakfast_free_for_children_under: '',
				parking_onsite: false,
				parking_obligatory_reservation: false,
				parking_supplement: '',
				parkingConditions: '',
				children_accepted: true,
				max_age_child: 12,
				max_age_child_free_stay: 2,
				is_extra_bed_available: false,
				extra_bed_supplement: '',
				is_baby_cot_available: false,
				baby_cot_supplement: '',
				childrenConditions: '',
				has_adaptations_for_handicaps: true,
				handicap_num_adapted_rooms: '',
				handicap_adaptations: [],
				animal_accepted: true,
				animal_supplement: '',
				animalsConditions: '',
				supplementary: '',
			},
			max_selected_services: 10,
			services: [],
			selected_services: [],
			rooms: [],
			room_services: [],
			selected_room_services: [],
			payment_methods: [],
			available_handicap_adaptations: [
				{
					value: 'reduced_mobility',
					text: 'Personnes à mobilité réduite',
				},

				{
					value: 'reduced_vision',
					text: 'Personnes malvoyantes',
				},

				{
					value: 'reduced_hearing',
					text: 'Personnes malentendantes',
				},

				{
					value: 'reduced_mental_capacity',
					text: 'Personnes avec un handicap mentale',
				},
			],
		};
	},

	beforeCreate() {
		let hash = this.$route.query.hash;

		this.axios
			.get('/questionnaires.json?hash=' + hash)
			.then((response) => {
				this.client.client_name =
					response.data.questionnaire.project.client.company_name;
				this.services = response.data.featured_services;
				this.room_services = response.data.room_services;
				this.payment_methods = response.data.payment_methods;

				if (this.isDefined(response.data.questionnaire.graphics)) {
					this.graphics = response.data.questionnaire.graphics;
				}

				if (
					this.isDefined(
						response.data.questionnaire.legal_information
					)
				) {
					this.legal = response.data.questionnaire.legal_information;
				}

				if (this.isDefined(response.data.questionnaire.conditions)) {
					this.conditions = response.data.questionnaire.conditions;

					if (
						this.isDefined(
							response.data.questionnaire.structured_time
								.check_in_time_from
						)
					) {
						this.conditions.check_in_time_from =
							response.data.questionnaire.structured_time.check_in_time_from;
					}

					if (
						this.isDefined(
							response.data.questionnaire.structured_time
								.check_in_time_to
						)
					) {
						this.conditions.check_in_time_to =
							response.data.questionnaire.structured_time.check_in_time_to;
					}

					if (
						this.isDefined(
							response.data.questionnaire.structured_time
								.check_out_time_to
						)
					) {
						this.conditions.check_out_time_to =
							response.data.questionnaire.structured_time.check_out_time_to;
					}

					if (
						this.isDefined(
							response.data.questionnaire.structured_time
								.free_cancellation_time
						)
					) {
						this.conditions.free_cancellation_time =
							response.data.questionnaire.structured_time.free_cancellation_time;
					}
				}

				if (
					this.isDefined(
						response.data.questionnaire.featured_services
					)
				) {
					this.selected_services = Object.values(
						response.data.questionnaire.featured_services
					);
				}

				if (this.isDefined(response.data.questionnaire.room_services)) {
					this.selected_room_services = Object.values(
						response.data.questionnaire.room_services
					);
				}

				if (this.isDefined(response.data.questionnaire.rooms)) {
					this.rooms = response.data.questionnaire.rooms;
				}

				this.loading = false;
			})
			.catch(() => {
				// this.$router.push("/");
			});
	},
	methods: {
		onSubmit() {
			this.is_completed = true;
			this.saveQuestionnaire().then(() => {
				this.$router.push('/questionnaire-complete');
			});
		},
		saveQuestionnaire() {
			var self = this;
			return new Promise(function(resolve, reject) {
				let hash = self.$route.query.hash;

				self.axios
					.post('/questionnaires/add.json?hash=' + hash, {
						is_completed: self.is_completed,
						graphics: self.graphics,
						featured_services: self.selected_services,
						legal_information: self.legal,
						conditions: self.conditions,
						rooms: self.rooms,
						room_services: self.selected_room_services,
					})
					.then((response) => {
						if (response.data.status == 'success') {
							resolve(response.data.status);
						} else {
							reject();
						}
					})
					.catch(function(err) {
						reject(err);
					});
			});
		},
		beforeTabSwitch: function() {
			this.saveQuestionnaire();
			window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
			return true;
		},
		isFeaturedServiceDisabled: function(value) {
			return (
				this.selected_services.length >= this.max_selected_services &&
				this.selected_services.indexOf(value) == -1
			);
		},
		isDefined(variable) {
			return typeof variable !== 'undefined' && variable != null;
		},
	},
};
</script>

<style lang="scss">
#checkbox-featured-services {
	column-count: 3;
	text-align: left;

	.custom-control-inline {
		display: block;
		margin-bottom: 8px;
	}
}

.checkbox-container {
	column-count: 3;
	margin-bottom: 30px;

	.custom-checkbox {
		text-align: left;
	}
}
</style>
